<template>
  <el-dialog 
    :modal-append-to-body="false"
    :title="openType === 'add' ? '新增自定义页面' : '编辑自定义页面'"
    :visible.sync="visible"
    :close-on-click-modal="false"
    width="65%"
    custom-class="customModal">
    
    <el-form ref="form" :model="formValue" :rules="rules">
      <el-row>
        <el-col :span="24">
          <el-form-item prop="title" class="formItemFill" label="标题">
            <el-input v-model="formValue.title" size="small" autocomplete="off"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
         <el-form-item prop="is_enable" class="formItemFill" label="是否启用" >
            <el-radio-group v-model="formValue.is_enable" size="small" style="width: 100%">
              <el-radio-button :label="true">是</el-radio-button>
              <el-radio-button :label="false">否</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="is_header" class="formItemFill" label="是否含有头部" >
            <el-radio-group v-model="formValue.is_header" size="small" style="width: 100%">
              <el-radio-button :label="true">是</el-radio-button>
              <el-radio-button :label="false">否</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
         <el-form-item prop="is_footer" class="formItemFill" label="是否含有尾部" >
            <el-radio-group v-model="formValue.is_footer" size="small" style="width: 100%">
              <el-radio-button :label="true">是</el-radio-button>
              <el-radio-button :label="false">否</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="is_full_screen" class="formItemFill" label="是否满屏" >
            <el-radio-group v-model="formValue.is_full_screen" size="small" style="width: 100%">
              <el-radio-button :label="true">是</el-radio-button>
              <el-radio-button :label="false">否</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
        <vue-ueditor-wrap v-model="formValue.content" :config="myConfig"></vue-ueditor-wrap>
    <div slot="footer" class="dialog-footer">
      <AppButton type="primary" @click="submit" size="small">提交</AppButton>
      <AppButton @click="close" size="small">取 消</AppButton>
    </div>
  </el-dialog>
</template>

<script>
import { WebsiteService } from '../../service/website.service';
import VueUeditorWrap from 'vue-ueditor-wrap'
import { Storage } from '../../service/core/storage'

  export default {
    name: 'formCustomPage',
    components: { VueUeditorWrap  },
    data() {
      return {
        msg: '',
        myConfig: {
      // 编辑器不自动被内容撑高
        autoHeightEnabled: false,
        // 初始容器高度
        initialFrameHeight: 400,
        // 初始容器宽度
        initialFrameWidth: '100%',
        // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
        //serverUrl: 'http://35.201.165.105:8000/controller.php',
        serverUrl: 'https://api.goodyiyao.cn/index.php/api/File_logic/upload?action=config&action=uploadimage&encode=utf-8&path_type=custom_view',
        // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
        UEDITOR_HOME_URL: '/ue/'
        },
        visible: false,
        openType: '',
        formValue: { },
        checkAll: false,
        event_type:'',
        platform: '',
        hideUpload: false,
        limitCount:1,
        fileData:{
          access_token: Storage.get('token'),
          path_type: "goods",
          action: "uploadimage",
          upfile: ''
        },
        img_url:'',
        rules: {
          title: [{ required: true, message: '标题不能为空'}],
          sort: [
            { required: true, message: '顺序不能为空'},
            
          ]
        },
      }
    },
    methods: {
      async open(type, data, platform,event_type) {
        this.platform = platform
        this.event_type = event_type
        if (type === 'add') {
          this.reset();
        } else if (type === 'edit' && data) {
          this.formValue = JSON.parse(JSON.stringify(await WebsiteService.getListByCustomPage('','',data.id)))
          this.formValue.is_enable = this.formValue.is_enable === 1 ? true : false
          this.formValue.is_header = this.formValue.is_header === 1 ? true : false
          this.formValue.is_footer = this.formValue.is_footer === 1 ? true : false
          this.formValue.is_full_screen = this.formValue.is_full_screen === 1 ? true : false
        }
        this.openType === type;
        this.visible = true;
      },
      reset() {
        this.formValue = {
          is_enable: true,
//          sort: 50,
          is_header: true,
          is_footer: true,
          is_full_screen:true
        };

      },
      async submit() {
          this.formValue.is_enable = this.formValue.is_enable === true ? 1 : 0
          this.formValue.is_header = this.formValue.is_header === true ? 1 : 0
          this.formValue.is_footer = this.formValue.is_footer === true ? 1 : 0
          this.formValue.is_full_screen = this.formValue.is_full_screen === true ? 1 : 0
          await WebsiteService.submitcustomView(this.formValue);
          this.$emit('submitSuccess')
          this.close();
      },
      handleRemove(file, fileList) {
        this.hideUpload = fileList.length >= this.limitCount
      },
      // handlePreview(file) {
      //   console.log(file);
      // },
      // beforeUpload(file) {
      // },
      changeIMG(file,fileList) {
        this.hideUpload = fileList.length >= this.limitCount
        this.fileData.upfile = file.raw
      },
      submitIMG() {
        this.$nextTick(() => {
            this.$refs.upload.submit()
        })
      },
      onSuccess(res) {
        this.formValue.images_url = res.data.sub_path
      },
      close() {
        this.visible = false;
        this.formValue = {};
      },
      returnContent() {
        this.dat.content = this.$refs.ue.getUEContent();
      },
      showContent() {
        this.show = !this.show;
      }

    }
  }
</script>

<style lang="scss" scoped>

.treeTable {
  height: 29vw;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>

<style lang="scss">
  .formItemFill .el-dialog__wrapper{
    z-index: 2500!important;
  }
</style>